import { render, staticRenderFns } from "./RevenueTips.vue?vue&type=template&id=6dced725&scoped=true"
import script from "./RevenueTips.vue?vue&type=script&lang=js"
export * from "./RevenueTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dced725",
  null
  
)

export default component.exports